module.exports = __webpack_public_path__ + "Menu.png?0f764a46da6c00dbf4608b6686340c51";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Menu.png
// module id = 144
// module chunks = 0